import React from 'react';
import LetterText from './LetterText';

function ArchiveDetailPage({ archive, onBack }) {
  if (!archive) return null;
  const { letterContent, dateArchived, title } = archive;
  return (
    <div className="archive-detail-page" style={{ padding: '2em', maxWidth: 600, margin: '0 auto' }}>
      <button onClick={onBack} style={{ marginBottom: '1em' }}>Back to Archives</button>
      <h2 style={{ color: '#c94f7c', marginBottom: '0.5em' }}>{title}</h2>
      <div style={{ color: '#b07a8c', fontSize: '0.95em', marginBottom: '1em' }}>{dateArchived}</div>
      {letterContent.image && (
        <img
          src={letterContent.image}
          alt="Archived memory"
          style={{ maxWidth: '100%', borderRadius: '12px', marginBottom: '1em', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}
        />
      )}
      <p className="greeting">{letterContent.greeting}</p>
      <LetterText text={letterContent.text} photos={letterContent.photos} />
      <p className="closing">{letterContent.closing}</p>
      <p className="signature">{letterContent.signature}</p>
    </div>
  );
}

export default ArchiveDetailPage;
